import React, { createContext, useContext, useEffect, useState } from 'react';
import { defaultSiteConfig, SiteConfig } from '@/lib/siteConfig';

interface SiteConfigContextValue {
  config: SiteConfig;
  isLoading: boolean;
}

const SiteConfigContext = createContext<SiteConfigContextValue>({
  config: defaultSiteConfig,
  isLoading: true,
});

export function SiteConfigProvider({ children }: { children: React.ReactNode }): React.JSX.Element {
  const [config, setConfig] = useState<SiteConfig>(defaultSiteConfig);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch('/config.json')
      .then(res => res.json() as Promise<Partial<SiteConfig>>)
      .then(data => {
        setConfig({
          ...defaultSiteConfig,
          ...data,
          analytics: { ...defaultSiteConfig.analytics, ...data.analytics },
        });
      })
      .catch(() => {
        // Fall back to defaults silently on fetch or parse error
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <SiteConfigContext.Provider value={{ config, isLoading }}>
      {children}
    </SiteConfigContext.Provider>
  );
}

export function useSiteConfig(): SiteConfigContextValue {
  return useContext(SiteConfigContext);
}
